import _ from 'lodash';

export const isAlertsFetchingSelector = state => _.get(state, 'alerts.isFetching');
export const getAlertsSelector = state => _.get(state, 'alerts.alerts', []);
